<template>
  <div class v-if="chamados.length">
    <label for="combobox" v-if="chamados[0].codigo">Selecione um chamado</label>
    <v-select
      label="label"
      class="mt-2"
      :options="chamados"
      v-model="selected"
      v-if="chamados[0].codigo"
    ></v-select>
    <div v-else class="col-md-12 mt-1 p-0">
      <div class="card absolute border-0">
        <h5 class="d-flex justify-content-center align-items-center">
          <i class="material-icons pr-2 py-3 blue color-blue">info</i> Você
          ainda não possui nenhum chamado ativo
        </h5>
      </div>
    </div>
    <transition mode="out-in">
      <div
        class="card border-0 chamado shadow-sm mt-4"
        placeholder="Selecione um chamado..."
        v-if="selected"
      >
        <small>código - {{ selected.codigo }}</small>
        <h5 class="d-flex align-items-center">
          <i class="material-icons pr-2">flag</i>
          {{ selected.label }}
        </h5>
        <hr />
        <p class="p-2 mb-3 motivo pb-0" v-if="selected.tipoultimasolucao">
          {{ selected.tipoultimasolucao }} - {{ selected.ultimasolucao }}
        </p>
        <p class="p-2" v-if="selected.ultimasolucao">Última Solução</p>
        <small class="pb-4 p-2" v-if="selected.ultimasolucao">{{
          selected.ultimasolucao
        }}</small>
        <div class="d-flex justify-content-between px-2">
          <p>
            Aberto em
            <b>{{ selected.dataAbertura }}</b>
          </p>
          <p
            :class="selected.status == '1' && '2' ? 'danger' : 'success'"
            class="text-uppercase"
          >
            {{ statusStr[selected.status].name }}
          </p>
        </div>
      </div>
    </transition>
    <div class="row mt-5 flex-column-reverse flex-md-row">
      <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
        <Botao
          title="Voltar"
          @click="$router.push({ name: 'painelAssociado' })"
          nameClass="btn btn-outline-secondary btn-lg btn-block"
          >VOLTAR</Botao
        >
      </div>
    </div>
  </div>
  <loading v-else />
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Botao from "@/components/botoes/Botao";

export default {
  name: "ConsultorChamados",
  components: {
    vSelect,
    Botao,
  },
  data() {
    return {
      produto: {
        nome: "Painel do Associado",
        id: "painelAssociado",
      },
      breadcrumb: [
        {
          nome: "CDL Consultor",
          id: "CDL Consultor",
          link: "/produto/cdl-consultor/minha-carteira",
        },
        {
          nome: "Painel do Associado",
          id: "painelAssociado",
          link: "/produto/cdl-consultor/painel-associado",
        },
        {
          nome: "Chamados",
          id: "chamados",
        },
      ],
      chamados: [],
      resultados: null,
      selected: null,
      statusStr: [
        {
          name: "Aberto",
        },
        {
          name: "Cancelado",
        },
        {
          name: "Finalizado",
        },
      ],
    };
  },
  methods: {
    formatDate(value) {
      var options = { year: "numeric", month: "numeric", day: "numeric" };
      return value.toLocaleString("pt-BR", options);
    },
    getChamados() {
      this.codSocio = localStorage.getItem("associadoSelecionado");
      this.$http
        .get(`/api/Consultor/ConsultarChamados?codSocio=${this.codSocio}`)
        .then((response) => {
          var value = response.data;
          function compare(a, b) {
            if (
              new Date(a.dataAbertura).getTime() >
              new Date(b.dataAbertura).getTime()
            ) {
              return -1;
            }
            if (
              new Date(a.dataAbertura).getTime() <
              new Date(b.dataAbertura).getTime()
            ) {
              return 1;
            }
            return 0;
          }

          value.sort(compare);
          this.chamados = value;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.getChamados();
  },
};
</script>

<style lang="scss" scoped></style>
